import './scripts/common';
import './scripts/common-nav';
import {translate} from '@elements/translations';

let _config = window['_config'] || {};

// @ts-ignore
window.app = window['app'] || {
    debug: false,
};

// Todo: Add page specific JS here e.g:
import * as lightbox from './scripts/lightbox';
lightbox.init();

import * as lazyIframe from '@elements/lazy-iframe';
lazyIframe.init();

function customArrowRenderFunction(container, direction, disabled, options) {
    let markupElement = document.createElement('div'),
        arrowMarkup = `<button type="button" class="${options.arrowClass} ${direction === 0 ? options.arrowPrevClass : options.arrowNextClass}" aria-label="${direction === 0 ? options.arrowAriaLabelPrev : options.arrowAriaLabelNext}" ${disabled ? 'disabled' : ''}><span class="scroll-slider__arrow-icon ${options.arrowIconClass}" aria-hidden="true" title="Search"></span></button>`;
    markupElement.innerHTML = arrowMarkup;
    let newArrow = markupElement.childNodes[0];
    container.appendChild(newArrow);

    return newArrow;
}

import * as scrollSlider from '@elements/scroll-slider';
scrollSlider.init({
    arrowIconClass:"icon icon-chevron",
    arrowAriaLabelPrev: translate('scroll-slider.arrow.previous'),
    arrowAriaLabelNext: translate('scroll-slider.arrow.next') ,
    slides: 3,
    arrowRenderFunction: customArrowRenderFunction
});

function dotsDefaultRenderFunction(id = null, dotContainer, options) {
    let dotNamesArray = JSON.parse(dotContainer.dataset.imgTextSliderDotNames);
    let markupElement = document.createElement('div'),
        dotMarkup = `<button type="button" class="img-text-slider__dot js-scroll-slider__dots-btn ${id === 0 ? 'is-active' : '' }"><span class="scroll-slider__dot-text">${dotNamesArray[id]}</span></button>`;
    markupElement.innerHTML = dotMarkup;
    let newDot = markupElement.childNodes[0];
    dotContainer.appendChild(newDot);

    return newDot;
}

scrollSlider.init({
    arrowIconClass:"icon icon-chevron",
    arrowAriaLabelPrev: translate('scroll-slider.arrow.previous'),
    arrowAriaLabelNext: translate('scroll-slider.arrow.next'),
    arrowRenderFunction: customArrowRenderFunction,
    dots: true,
    dotsRenderFunction: dotsDefaultRenderFunction
}, {
    base: '.js-img-text-slider',
    area: '.js-img-text-slider__area',
    item: '.js-img-text-slider__item',
    dotsContainer: '.js-img-text-slider__dots-container'
});
